module.exports = __webpack_public_path__ + "../assets/img/b5af87888b8ce829358c727edb7b0219.svg";